<div class="step-tooltip" [class]="arrowClass">
  <!-- Arrow pointer -->
  <div class="arrow"></div>

  <!-- Content -->
  <div class="tooltip-content">
    <p class="tooltip-eyebrow" *ngIf="eyebrow">{{ eyebrow }}</p>
    <h2 class="tooltip-title" *ngIf="title">{{ title }}</h2>
    <p class="tooltip-message">{{ message }}</p>

    <div class="tooltip-media" *ngIf="mediaUrl">
      <img [src]="mediaUrl" alt="Step visual hint" />
    </div>

    <div class="tooltip-actions">
      <button class="btn btn-ghost"
              *ngIf="canGoBack"
              (click)="onBack()">
        Back
      </button>

      <button class="btn btn-primary"
              *ngIf="showNext"
              (click)="onNext()">
        Got it
      </button>

      <button class="btn btn-secondary"
              *ngIf="!showNext">
        Click the highlighted element
      </button>

      <button class="btn btn-link"
              *ngIf="showSkip"
              (click)="onSkip()">
        Skip
      </button>
    </div>
  </div>
</div>
